import { $http } from "@/utils/https";
import type { CatalogCategoriesResponse } from "@/types/catalog";

interface State {}

const state: State = {};

const getters = {};

const actions = {
  GET_CATEGORIES: async () => {
    try {
      const response = await $http.get<CatalogCategoriesResponse>("v1/catalog/categories");
      return response.data;
    } catch (e) {
      throw e;
    }
  },
};

const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
